/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const AttachmentStateDto = {
    New: 'NEW',
    Uploaded: 'UPLOADED',
    Error: 'ERROR',
    Deleted: 'DELETED',
    External: 'EXTERNAL',
} as const;

export type AttachmentStateDto = typeof AttachmentStateDto[keyof typeof AttachmentStateDto];



